c_styles = {};
c_menus = {};
c_hideTimeout = 500;
c_subShowTimeout = 10;
c_keepHighlighted = true;
c_findCURRENT = true;
c_findCURRENTTree = true;
c_overlapControlsInIE = true;
c_rightToLeft = false;
c_styles['MM'] = [
    [1, 'solid', '#efefef', 0, '#FFFFFF', '', ''],
    [1, 'solid', 'solid', 'solid', '#efefef', 4, 'transparent', '#f5f5f5', '#000000', '#000000', '12px', 'verdana,arial,helvetica,sans-serif', 'normal', 'none', 'none', 'left', 1, 'solid', 'transparent', 0, true, '[v_arrow_black.gif]', '[v_arrow_black.gif]', 7, 7, '8', 'solid', '#FFFFFF', '#FFFFFF', '#000000', 'none', '[v_arrow_black.gif]', 'solid', '#f5f5f5', '#f7f7f7', '#000000', 'none', '[v_arrow_black.gif]', '', '', '', '']
];
c_styles['SM'] = [
    [1, 'solid', '#C0C0C0', 3, '#FFFFFF', '', ''],
    [1, 'solid', 'solid', '#FFFFFF', '#efefef', 3, '#FFFFFF', '#f5f5f5', '#000000', '#000000', '11px', 'verdana,arial,helvetica,sans-serif', 'normal', 'none', 'none', 'left', 1, 'solid', 'transparent', 2, true, '[v_arrow_black.gif]', '[v_arrow_black.gif]', 7, 7, '7', 'solid', '#FFFFFF', '#FFFFFF', '#000000', 'none', '[v_arrow_black.gif]', 'solid', '#f5f5f5', '#f5f5f5', '#000000', 'none', '[v_arrow_black.gif]', '', '', '', '']
];
c_styles['Popup'] = [
    [1, 'solid', '#c0c0c0', 2, '#fff', '', ''],
    [1, 'solid', 'solid', 'transparent', '#efefef', 3, '#fff', '#f5f5f5', '#000000', '#000000', '12px', 'arial,helvetica,sans-serif', 'normal', 'none', 'none', 'left', 1, 'solid', 'transparent', 0, true, '[v_arrow_black.gif]', '[v_arrow_black.gif]', 7, 7, '7', 'solid', '#fff', '#fff', '#000000', 'none', '[v_arrow_black.gif]', 'solid', '#efefef', '#f9f9f9', '#000000', 'none', '[v_arrow_black.gif]', '', '', '', '']
];
c_menus['Menu1'] = [
    ['horizontal', 'absolute', '2em', '2em', false, false, 0, 0, '200px', 'MM', false],
    [5, 1, '180px', '200', '300', 'SM', false]
];
c_menus['PopupMenu1'] = [
    ['vertical', 'popup', '2em', '2em', false, false, 5, 1, '180px', 'Popup', false],
    [5, 1, '180px', '170', '300', 'Popup', false]
];